/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { LocalStorageService } from '../../core/services/localstorage.service';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import dayjs from 'dayjs';
import { DateRangeComponent } from '../date-range/date-range.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { Subscription } from 'rxjs';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'zuper-daterange',
    templateUrl: './zuper-daterange.component.html',
    styleUrls: ['./zuper-daterange.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ZuperDateRangeComponent implements OnInit, OnDestroy, OnChanges {
    @Input() module: string;
    @Input() showCloseIcon: boolean = true;
    @Input() saveInLocalStorage: boolean = true;
    @Input() dateRanges: any = [];
    @Input() allowMaxDate: boolean = true;
    @Input() showDate: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() placeholder: string;
    @Input() resetMaxDate: any = {
        count : 3,
        unit: 'months'
    };
    selected: any = {};
    selectedDateKey = '';
    get defaultDateRange(): any {
        return [{
            key: `${this.utilityService.getLocaleValue('daterange.range.today.label', 'Today')}`,
            rangeKey: 'TODAY',
            value: [dayjs(), dayjs()]
        },
        {
            key: `${this.utilityService.getLocaleValue('daterange.range.yesterday.label', 'Yesterday')}`,
            rangeKey: 'YESTERDAY',
            value: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')]
        },
        {
            key: `${this.utilityService.getLocaleValue('daterange.range.seven.days.label', 'Last 7 Days')}`,
            rangeKey: 'LAST_7_DAYS',
            value: [dayjs().subtract(7, 'days'), dayjs().subtract(1, 'days')]
        },
        {
            key: `${this.utilityService.getLocaleValue('daterange.range.thirty.days.label', 'Last 30 Days')}`,
            rangeKey: 'LAST_30_DAYS',
            value: [dayjs().subtract(30, 'days'), dayjs().subtract(1, 'days')]
        },
        {
            key: `${this.utilityService.getLocaleValue('daterange.range.thismonth.label', 'This Month')}`,
            rangeKey: 'THIS_MONTH',
            value: [dayjs().startOf('month'), dayjs().endOf('month')]
        },
        {
            key: `${this.utilityService.getLocaleValue('daterange.range.lastmonth.label', 'Last Month')}`,
            rangeKey: 'LAST_MONTH',
            value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
        }]
    }
    ranges: any = [];
    selectedRange: any = { label: '', dates: [] };
    mockDateRange: any = { label: '', dates: [] };
    displayDate: any;
    selectedDateValue: any;
    onZuperDateUpdatedSubscription: Subscription;
    constructor(public utilityService: UtilityService, private elementRef: ElementRef, private _localStorageService: LocalStorageService, private _zuperDialogService: ZuperDialogService, private dateFormatPipe: DateFormatPipe, private datePipe: DatePipe, private translateService: TranslateService) { }

    ngOnInit(): void {
        if(this.dateRanges.length){
            this.ranges = [...this.dateRanges];
            if(this.showDate){
                this.ranges = this.ranges.filter((item: any)=>item?.value?.length > 0);
            }
        }else{
            this.ranges = this.defaultDateRange;
        }
        if (this._localStorageService.getLocalStorage(this.module.toLowerCase() + '_date')) {
            const range = this._localStorageService.getLocalStorage(this.module.toLowerCase() + '_date');
            if (range?.key === 'CUSTOM_RANGE') {
                this.utilityService.OnZuperDateSelected.next(range.value);
                this.updateSelectedDate(range?.value);
            } else {
                const filteredRange: any[] = this.ranges.filter((value: any) => range.key === value.rangeKey);
                if (filteredRange?.length) {
                    const date: any = {
                        startDate: dayjs(filteredRange[0]?.value[0]).format('YYYY-MM-DD'),
                        endDate: dayjs(filteredRange[0]?.value[1]).format('YYYY-MM-DD')
                    };
                    this.utilityService.OnZuperDateSelected.next(date);
                    this.updateSelectedDate(date, filteredRange[0].key);
                }
                else if (!filteredRange?.length && this.showDate) {
                    // this.utilityService.OnZuperDateUpdated.next({
                    //     'key': 'TODAY',
                    //     'startDate': dayjs(),
                    //     'endDate': dayjs()
                    // });
                    const date: any = {
                        startDate: dayjs().format('YYYY-MM-DD'),
                        endDate: dayjs().format('YYYY-MM-DD')
                    };
                    this.utilityService.OnZuperDateSelected.next(date);
                    this.updateSelectedDate(date, 'Today');
                }
            }
        } else {
            this.resetDateRange();
            this.onZuperDateUpdatedSubscription = this.utilityService.OnZuperDateUpdated.subscribe((updateDate: any) => {
                if (updateDate) {
                    let date: any = updateDate;
                    if (date.key && date?.key !== 'CUSTOM_RANGE') {
                        const filteredRange: any[] = this.ranges.filter((value: any) => date.key === value.rangeKey);
                        if (filteredRange?.length) {
                            date = {
                                key: filteredRange[0].rangeKey,
                                startDate: dayjs(filteredRange[0]?.value[0]).format('YYYY-MM-DD'),
                                endDate: dayjs(filteredRange[0]?.value[1]).format('YYYY-MM-DD')
                            };
                        }
                    }
                    this.selectedRange.label = date?.key ?? 'CUSTOM_RANGE';
                    this.selected = { startDate: dayjs(date?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), endDate: dayjs(date?.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD') };
                    this.datesUpdated(date);
                    this.getSelectedDate(date);
                }
                else
                {
                    this.selected = { startDate: null, endDate: null };
                    this.selectedDateKey = this.placeholder? this.placeholder : this.translateService.instant('text.select_date_range');
                }
            });
        }
    };

    datesUpdated(event: any): void {
        this.selectedRange = { label: event?.key ?? 'CUSTOM_RANGE', dates: [this.selected.startDate, this.selected.endDate] };
        if (this.selected?.startDate && this.selected?.endDate) {
            const range = {
                key: event?.key ?? 'CUSTOM_RANGE',
                value: this.convertDate(this.selected)
            };
            if (this.saveInLocalStorage) {
                this._localStorageService.setLocalStorage(this.module.toLowerCase() + '_date', range);
            }
            this.utilityService.OnZuperDateSelected.next(this.saveInLocalStorage ? range.value : range);
        }

        this.getSelectedDate(this.selected);
    }

    getSelectedDate(event): void {
        if (this.selectedRange.label === 'CUSTOM_RANGE') {
            const startDate = this.utilityService.convertDateWithMonthNames(event.startDate, this.dateFormat);
            const endDate = this.utilityService.convertDateWithMonthNames(event.endDate, this.dateFormat);
            if(!this.showDate){
            if (startDate === endDate) {
                this.selectedDateKey = `${startDate}`;
            } else {
                this.selectedDateKey = `${startDate} - ${endDate === null ? startDate : endDate}`;
            }
            }
            else if (this.showDate) {
                const customStartDate = event.startDate;
                const customEndDate = event.endDate;
                if (customStartDate === customEndDate) {
                    this.selectedDateKey = this.datePipe.transform(customStartDate, 'dd MMM yyyy');
                } else {
                    const startYear = this.datePipe.transform(customStartDate, 'yyyy');
                    const endYear = this.datePipe.transform(customEndDate, 'yyyy');

                    if (startYear === endYear) {
                        this.selectedDateKey = this.datePipe.transform(customStartDate, 'dd MMM') + '-' + this.datePipe.transform(customEndDate, 'dd MMM yyyy');
                    } else {
                        this.selectedDateKey = this.datePipe.transform(customStartDate, 'dd MMM yyyy') + '-' + this.datePipe.transform(customEndDate, 'dd MMM yyyy');
                    }
                }
            }
        } else {
            const filteredRange: any[] = this.ranges.filter((value: any) => this.selectedRange.label === value.rangeKey);
            this.selectedDateKey = filteredRange?.length ? filteredRange[0].key : this.utilityService.getLocaleValue('text.custom_range', 'Custom Range');
            if(this.showDate){
               this.updateSelectedDateValue(filteredRange);
            }
        }
    }
    updateSelectedDateValue(filteredRange: any): void {
        const startDate = !filteredRange?.startDate ? filteredRange[0]?.value[0] : filteredRange?.startDate;
        const endDate = !filteredRange?.endDate ? filteredRange[0]?.value[1] : filteredRange?.endDate;
        if (this.showDate) {
          if (startDate === endDate || filteredRange[0]?.rangeKey === 'TODAY') {
            this.selectedDateValue = ' ' + this.datePipe.transform(startDate, 'dd MMM yyyy');
          } else {
            const startYear = this.datePipe.transform(startDate, 'yyyy');
            const endYear = this.datePipe.transform(endDate, 'yyyy');
            if (startYear === endYear) {
              this.selectedDateValue = ' ' + this.datePipe.transform(startDate, 'dd MMM') + '-' + this.datePipe.transform(endDate, 'dd MMM yyyy');
            } else {
              this.selectedDateValue = ' ' + this.datePipe.transform(startDate, 'dd MMM yyyy') + '-' + this.datePipe.transform(endDate, 'dd MMM yyyy');
            }
          }
        }
      }

    updateSelectedDate(date, dateKey?: string): void {
        this.selected = { startDate: dayjs(date?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), endDate: dayjs(date?.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD') };
        if (dateKey) {
            this.selectedDateKey = dateKey;
            if(this.showDate){
                this.updateSelectedDateValue(date);
            }
        } else {
            if(!this.showDate){
            const startDate = dayjs(date?.startDate, 'YYYY-MM-DD').format(this.dateFormat);
            const endDate = dayjs(date?.endDate, 'YYYY-MM-DD').format(this.dateFormat);
            this.selectedDateKey = `${startDate} - ${endDate}`;
            }
            else if(this.showDate) {
                const customStartDate = date?.startDate;
                const customEndDate = date?.endDate;
                if (customStartDate === customEndDate) {
                    this.selectedDateKey = this.datePipe.transform(customStartDate, 'dd MMM yyyy');
                  } else {
                    const startYear = this.datePipe.transform(customStartDate, 'yyyy');
                    const endYear = this.datePipe.transform(customEndDate, 'yyyy');
                    if (startYear === endYear) {
                      this.selectedDateKey =  this.datePipe.transform(customStartDate, 'dd MMM') + '-' + this.datePipe.transform(customEndDate, 'dd MMM yyyy');
                    } else {
                      this.selectedDateKey = this.datePipe.transform(customStartDate, 'dd MMM yyyy') + '-' + this.datePipe.transform(customEndDate, 'dd MMM yyyy');
                    }
                  }
            }
        }
    }

    resetDateRange(): void {
        this.selected = { startDate: null, endDate: null };
        this.selectedDateKey = this.placeholder? this.placeholder : this.translateService.instant('text.select_date_range');
        this._localStorageService.removeLocalStorage(this.module.toLowerCase() + '_date');
        this.utilityService.OnZuperDateSelected.next(this.selected);
    }

    get dateFormat(): string {
        return this.utilityService.dateFormat;
    }

    get daterangelabel(): string {
        return this.utilityService.getLocaleValue('text.apply');
    }

    get cancellabel(): string {
        return this.utilityService.getLocaleValue('cancel.text');
    }

    get isCloseVisible(): boolean {
        return this.selected?.startDate !== null && this.selected?.endDate !== null && this.showCloseIcon;
    }

    updateDate(dateRange: any): void {
        let date = {
            startDate: dateRange?.value[0],
            endDate: dateRange?.value[1]
        };
        this.selectedRange = { label: dateRange.key ?? 'CUSTOM_RANGE', dates: [this.selected.startDate, this.selected.endDate] };
        date = this.convertDate(date);
        this.selected = date;
        const range = {
            key: dateRange.rangeKey,
            value: date
        };
        this.selectedDateKey = dateRange.key;
        if(this.showDate){
           this.updateSelectedDateValue(date);
        }
        if (this.saveInLocalStorage) {
            this._localStorageService.setLocalStorage(this.module.toLowerCase() + '_date', range);
        }
        this.utilityService.OnZuperDateSelected.next(this.saveInLocalStorage ? date : range);
    }

    convertDate(dateToBeUpdated: any): any {
        const date = { ...dateToBeUpdated };
        if (date.startDate && date.endDate) {
            date.startDate = dayjs(date.startDate).format('YYYY-MM-DD');
            date.endDate = dayjs(date.endDate).format('YYYY-MM-DD');
            return { ...date };
        } else {
            return { ...date };
        }
    }

    openDateRangePicker(): void {
        const dateRangeDialog: any = this._zuperDialogService.openCustom(DateRangeComponent, {
            disableClose: true,
            dismissible: false,
            extraClass: 'date-range',
            hasBackdrop: true,
            data: {
                data: this.selected,
                allowMaxDate: this.allowMaxDate,
                maxLimitCount: this.resetMaxDate.count,
                maxLimitUnit: this.resetMaxDate.unit
            }
        });
        dateRangeDialog.afterClosed().subscribe((data: any) => {
            if (data.result) {
                this.selected = { startDate: dayjs(data?.dateRange?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), endDate: dayjs(data?.dateRange?.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD') };
                this.datesUpdated(data?.dateRange);
            }
        });
    }
    ngOnDestroy(): void {
        this.onZuperDateUpdatedSubscription?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void{
        if(changes?.resetMaxDate){
            this.resetMaxDate = changes?.resetMaxDate?.currentValue;
        }
        if(changes?.dateRanges){
            this.ranges = changes?.dateRanges?.currentValue;
        }
        if('isDisabled' in changes){
            this.isDisabled = changes?.isDisabled?.currentValue;
        }
    }
}
